export default __webpack_public_path__ + "68b51eba798df91811e48965b5075d89.png";